export default "__VITE_ASSET__67357a49__"